export default "__VITE_ASSET__DMf$qCBM__"